import { RedirectCommand, Router, Routes } from '@angular/router'
import { LayoutComponent } from './layouts/layout/layout.component'
import { inject } from '@angular/core'
import { AuthenticationService } from './core/service/auth.service'
import { PaginacaoLoadingService } from './core/service/paginacao-loading.service'

function rotaInicial(auth: AuthenticationService): string {
  return auth.isUsuarioExterno() ? '/taxon' : '/dashboard/geral'
}

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [
      () => {
        const auth = inject(AuthenticationService)
        const router = inject(Router)

        if (!auth.isAuthenticated()) {
          return new RedirectCommand(router.parseUrl('/auth/log-in'))
        }

        return new RedirectCommand(router.parseUrl(rotaInicial(auth)))
      },
    ],
    children: [],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [
      () => {
        const auth = inject(AuthenticationService)
        const router = inject(Router)

        if (auth.isAuthenticated()) {
          return true
        }

        return new RedirectCommand(router.parseUrl('/auth/log-in'), {})
      },
    ],
    canActivateChild: [
      () => !inject(PaginacaoLoadingService).carregando,
    ],
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEW_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: '**',
    canActivate: [
      () => {
        const auth = inject(AuthenticationService)
        const router = inject(Router)

        if (auth.isAuthenticated()) {
          return new RedirectCommand(router.parseUrl(rotaInicial(auth)))
        }

        return new RedirectCommand(router.parseUrl('/auth/log-in'))
      },
    ],
    children: [],
  },
]
